import { createBrowserRouter } from "react-router-dom";

import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Documents from "./pages/Documents";
import Audit from "./pages/Audit";
import Instructions from "./pages/Instructions";
import NotFound from "./pages/NotFound";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "about", element: <About /> },
      { path: "documents", element: <Documents /> },
      { path: "audit", element: <Audit /> },
      { path: "instructions", element: <Instructions /> },
      { path: "*", element: <NotFound /> },
    ],
  },
]);

export default router;
